import styled from 'styled-components';
import { pageEntry } from '../components/base/keyframes/fades';

const StyledRouteTransitions = styled('div')`
	position: relative;
	min-height: calc(100vh - ${props => props.theme.footer.footerHeightDesktop});
	height: 100;
	transform: translate3d(0, 0, 0);
	transform-style: preserve-3d;
	-webkit-backface-visibility: hidden;

	.fade-enter, .fade-enter-active, .fade-enter-done, .fade-exit, .fade-exit-active, .fade-exit-done {
		height: 100%;
		transform-style: preserve-3d;
	}

	.fade-enter {
		display: none;
	}

	.fade-enter-active {
		display: none;
	}

	.fade-enter-done {
		display: block;
		opacity: 0;
		animation: ${pageEntry} ${props => props.theme.routeTransitions.enterDuration}ms ease forwards;
	}

	.fade-exit {
		opacity: 1;
	}

	.fade-exit-active {
		opacity: 0;
		transition: all ${props => props.theme.routeTransitions.exitDuration}ms ease;
		transform: translate3d(0, 20px, 0);
	}

	.fade-exit-done {
	}
`;

export default StyledRouteTransitions;
